export default "__VITE_ASSET__Db086u5F__"